import { createStore } from 'vuex'
import user from './modules/user';

export default createStore({
  state: {
    type:"chinese",
    sidebarOpen:false,
    secretKey: "Lp9qVkzXy7FmKj8nBt0cHwQe1rT3sZxY5CvN2aD4fGh7i=", // 密钥
    isActivity: false
  },
  mutations: {
    setEnglish(state){
      state.type = "english";
    },
    setChinese(state){
      state.type = "chinese";
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebarOpen = !state.sidebarOpen
    },
    // 设置 secretKey
    SET_SECRET_KEY(state, newKey) {
      state.secretKey = newKey
    },
    // 设置活动状态
    SET_ACTIVITY_STATUS(state, status) {
      state.isActivity = status
    }
  },
  actions: {
      // 获取 secretKey（如果需要从接口获取）
      fetchSecretKey({ commit }) {
        // 如果 secretKey 需要从接口获取，可以在这里调用 API
        // 这里暂时直接使用已有的值，如果需要可以取消注释
        // const secretKey = "Lp9qVkzXy7FmKj8nBt0cHwQe1rT3sZxY5CvN2aD4fGh7i=";
        // commit('SET_SECRET_KEY', secretKey);
      },
      // 更新 secretKey（如果需要动态更新）
      updateSecretKey({ commit }, newKey) {
        commit('SET_SECRET_KEY', newKey)
      }
  },
  getters: {
    // 获取 secretKey
    secretKey: (state) => state.secretKey,
    // 获取活动状态
    isActivity: (state) => state.isActivity
  },
  modules: {
    user
  }
})
